'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$34() {
  this.ayQ = null;
  this.ayO = null;
  this.ayP = false;
  this.ayM = null;
  this.ayN = false;
  this.ayR = false;
  this.ayS = false;
  this.ayQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$34 as $c_Lpresto_AgentView$$anon$34 };
$p = $c_Lpresto_AgentView$$anon$34.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$34;
/** @constructor */
function $h_Lpresto_AgentView$$anon$34() {
}
export { $h_Lpresto_AgentView$$anon$34 as $h_Lpresto_AgentView$$anon$34 };
$h_Lpresto_AgentView$$anon$34.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.ayQ;
});
$p.t = (function() {
  if ((!this.ayP)) {
    this.ayO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("certchain", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("assinaturas", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayP = true;
  }
  return this.ayO;
});
$p.ae = (function() {
  if ((!this.ayN)) {
    this.ayM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().nN(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().cqH($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_KeyEncoder$().a68, $j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().nN()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayN = true;
  }
  return this.ayM;
});
$p.w = (function() {
  if ((!this.ayS)) {
    this.ayR = false;
    this.ayS = true;
  }
  return this.ayR;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$34 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$34, "presto.AgentView$$anon$34", ({
  DZ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$34 as $d_Lpresto_AgentView$$anon$34 };
//# sourceMappingURL=presto.-Agent-View$$anon$34.js.map
